<div class="rfid-reader">
  <sc-padding>
    <form class="form" [formGroup]="formGroup">
      <mat-form-field appearance="outline">
        <mat-label>{{
          "RFID"
          | translate
          : [
          "tmc-yard.widgets.yard-simulator.rfid-reader",
          translationService.language
          ]
          }}</mat-label>
        <mat-select (valueChange)="onCameraSelection($event)">
          <mat-option *ngFor="let rfid of rfids" [value]="rfid">
            {{ rfid.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <sc-flex [vertical]="true" [stretchContent]="true">
        <sc-string-field formControlName="scannedNumber" [label]="
            'RFID'
              | translate
                : [
                    'tmc-yard.widgets.yard-simulator.rfid-protocol',
                    translationService.language
                  ]
          " [required]="true">
        </sc-string-field>
      </sc-flex>
    </form>

    <button mat-flat-button class="config-changed-button" (click)="onButtonTrigger()"
      [disabled]="!scannedNumber || !rfidSelected">
      {{
      "send"
      | translate
      : [
      "tmc-yard.widgets.yard-simulator.send",
      translationService.language
      ]
      }}
    </button>
  </sc-padding>
</div>
